export default __webpack_public_path__ + "static/media/pn.2e59e547.svg";